import './Training.css';
import '../pages/Services/Services.css';

const Training = () => {
  const programs = [
    {
      title: 'Future-Ready Development',
      description: 'Master modern tech stack with industry experts.',
      duration: '12 weeks',
      level: 'Career Launcher',
      image: '/images/training/web-dev.png',
    },
    {
      title: 'Mobile Innovation Lab',
      description: 'Create the next generation of mobile experiences.',
      duration: '10 weeks',
      level: 'Skill Accelerator',
      image: '/images/training/mobile-dev.png',
    },
    {
      title: 'Cloud Mastery Program',
      description: 'Lead the cloud revolution with hands-on expertise.',
      duration: '8 weeks',
      level: 'Tech Pioneer',
      image: '/images/training/cloud-computing.png',
    },
    {
      title: 'DevOps Excellence',
      description: 'Shape the future of deployment and operations.',
      duration: '6 weeks',
      level: 'Innovation Driver',
      image: '/images/training/devops.png',
    },
  ];

  return (
    <div className="training-page">
      <div className="service-header">
        <h1>Learn With Us</h1>
        <p>Accelerate your tech career with hands-on expertise</p>
      </div>
      <div className="container">
        <div className="training-programs">
          {programs.map((program, index) => (
            <div className="program-card" key={index}>
              <div className="program-image">
                <img
                  src={program.image}
                  alt={program.title}
                  className="program-image"
                  loading={index === 0 ? 'eager' : 'lazy'}
                />
              </div>
              <div className="program-content">
                <h3>{program.title}</h3>
                <p>{program.description}</p>
                <div className="program-details">
                  <span>
                    <i className="fas fa-clock"></i> {program.duration}
                  </span>
                  <span>
                    <i className="fas fa-layer-group"></i> {program.level}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Training;
